import { Main } from './components';

export const Withdrawals = () => {
    return <Main />;
};

